import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';

import ColumnBox from 'components/ColumnBox';
import RowBox from 'components/RowBox';

import VisibilityIcon from '@mui/icons-material/Visibility';
import PanToolAltIcon from '@mui/icons-material/PanToolAlt';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ShortcutIcon from '@mui/icons-material/Shortcut';


import { useNavigate, createSearchParams } from 'react-router-dom';

import { apiHelper, baseUrl } from 'helpers/util'
import { notify } from 'helpers/globalFunctions';

import BigHeading from 'components/BigHeading';
import SmallHeading from 'components/SmallHeading';

export default function Form() {
    const links = [
        { "nativeActivity": "ManageNotificationsActivity", "title": "Manage Notifications" },
        { "link": "https://folk-connect.netlify.app/manage_events", "title": "Manage Events" },
        { "link": "https://folk-connect.netlify.app/manage_feed", "title": "Manage Feeds" },
        { "link": "https://folk-connect.netlify.app/manage_feed", "title": "Manage Feeds" },
        { "link": "https://folk-connect.netlify.app/trips_and_tours.html", "title": "Manage Trips & Tours" }
    ]

    const copyLink = function(link) {
        navigator.clipboard.writeText(link);
        notify.info({ "description": "Link Copied" });
    }
    const copyShortenedLink = function(link) {
        navigator.clipboard.writeText(link);
        notify.info({ "description": "Shortened Link Copied" });
    }

    const openLink = function(linkObject) {
        if (linkObject.link) { window.open(linkObject.link, '_blank'); }
        else if (linkObject.externalLink && window.AndroidApp) {
            window.AndroidApp.openExternalLink(linkObject.externalLink);
        } else if (linkObject.externalLink) {
            window.open(linkObject.externalLink, '_blank');
        } else if (linkObject.nativeActivity && window.AndroidApp) {
            window.AndroidApp.startNativeActivity(linkObject.nativeActivity);
        }
    }

    return (
        <ColumnBox>
            <SmallHeading sx={{ alignSelf: 'center' }}>Links Page</SmallHeading>
            <RowBox sx={{ width: '100%', justifyContent: 'center', alignItems: 'stretch' }}>
                { links.map(l => (
                    <Box sx={{ padding: '10px', width: '40%', maxWidth: '200px' }}>
                        <ColumnBox sx={{ border: '2px solid black', borderRadius: '5px',
                            padding: '10px' }}>
                            <Box sx={{ width: '100%', textAlign: 'center' }}>{l.title}</Box>
                            <RowBox sx={{ width: '100%' }}>
                                { l.link ?
                                <IconButton sx={{ flexGrow: 1 }} variant="outlined" color="primary"
                                    onClick={() => copyLink(l.link)}>
                                    <ContentCopyIcon />
                                </IconButton> : <></>}
                                { l.shortened_link ?
                                <IconButton sx={{ flexGrow: 1 }} variant="outlined" color="primary"
                                    onClick={() => copyShortenedLink(l.shortened_link)}>
                                    <ShortcutIcon />
                                </IconButton> : <></> }
                                <IconButton sx={{ flexGrow: 1 }} variant="outlined" color="primary"
                                    onClick={() => openLink(l)}>
                                    <PanToolAltIcon />
                                </IconButton>
                            </RowBox>
                        </ColumnBox>
                    </Box>
                )) }
            </RowBox>
        </ColumnBox>
    );
}
